<template>
  <!-- 取消会议、服务、报修相关组件 -->
  <van-action-sheet v-model="showSheet" :title="cancelTitle">
    <van-form label-align="right" label-width="75" @submit="onSubmit"
              validate-trigger="onSubmit" ref="cancelSheet">
      <van-field v-model="reason" rows="1" autosize type="textarea"
                 label="取消原因" placeholder="必填"
                 :rules="[{required: true, message: '请填写取消原因' }]"></van-field>
      <div class="mar-all">
        <van-button class="theme-btn" block size="small">确认并发送通知</van-button>
      </div>
    </van-form>
  </van-action-sheet>
</template>

<script>
  import {meeting, service, repair} from "../../../server"
  import {checkRespCorrect} from "../../../tools/utils";
  import {messageHdl, msgCode} from "../../../tools/messageHdlr";

  const cancelTypes = {
    meeting: "meeting",
    service: "service",
    repair: "repair",
  };
  export default {
    props: {
      show: Boolean,
      params: Object
    },
    data() {
      return {
        reason: ""
      }
    },
    computed: {
      showSheet: {
        get() {
          return this.show
        },
        set(val) {
          this.$emit('handle-cancel', val)
        },
      },
      cancelType() {
        if (this.params.mid) return cancelTypes.meeting;
        if (this.params.serviceId) return cancelTypes.service;
        if (this.params.repairId) return cancelTypes.repair;
      },
      cancelTitle() {
        switch (this.cancelType) {
          case cancelTypes.meeting:
            if (this.params && !this.params.isSubUpdate) {
              return "取消周期会议"
            }
            return "取消会议";
          case cancelTypes.service:
            return "取消服务";
          case cancelTypes.repair:
            return "取消报修";
          default:
            return ""
        }
      }
    },
    watch: {
      showSheet(val) {
        val && this.resetSheet()
      },
    },
    mounted() {
    },
    methods: {
      onSubmit() {
        if (!this.reason) return;
        const key = this.params.repairId ? "desc" : "cancelReason";
        const data = {
          ...this.params,
          [key]: this.reason
        };
        // console.log(data);
        UILoader.load("执行中...");
        this.showSheet = false;
        // 根据不同类型进入相应方法
        this.cancelType && this[this.cancelType + 'Cancel'](data)
      },
      // 取消会议
      meetingCancel(data) {
        meeting.cancelMeeting(this, data).then(({cancelMeeting: resp = {}}) => {
          if (checkRespCorrect(resp, "提交失败")) {
            messageHdl({code: msgCode.SUCCESS, msg: "提交成功"});
            this.$emit("reload")
          }
        }).catch(err => {
          messageHdl({msg: err.message});
        })
      },
      // 取消服务
      serviceCancel(data) {
        service.changeStatus(this, data).then(({changeServiceStatus: resp = {}}) => {
          if (checkRespCorrect(resp, "提交失败")) {
            messageHdl({code: msgCode.SUCCESS, msg: "提交成功"});
            this.$emit("reload")
          }
        }).catch(err => {
          messageHdl({msg: err.message});
        })
      },
      //取消报修
      repairCancel(data) {
        repair.changeStatus(this, data).then(({changeRepairStatus: resp = {}}) => {
          if (checkRespCorrect(resp, "提交失败")) {
            messageHdl({code: msgCode.SUCCESS, msg: "提交成功"});
            this.$emit("reload")
          }
        }).catch(err => {
          messageHdl({msg: err.message});
        })
      },
      resetSheet() {
        this.reason = "";
        this.$refs.cancelSheet && this.$refs.cancelSheet.resetValidation()
      }
    }
  }
</script>

<style scoped>
</style>
